import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { createTitle } from '@shared/utils/helpers';
import {
  TABLE_ICON_MAP,
  TableIconStatus,
} from '../table-icon/table-icon.const';
NgClass;

@Component({
  selector: 'ui-table-indicator',
  standalone: true,
  imports: [NgClass],
  templateUrl: './table-indicator.component.html',
  styleUrl: './table-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableIndicatorComponent {
  public readonly status = input.required<TableIconStatus>();

  protected readonly config = computed(() => TABLE_ICON_MAP[this.status()]);
  protected readonly label = computed(() => createTitle(this.status()));
  protected readonly bgCssClass = computed(() => this.config().backgroundColor);
  protected readonly iconCssClass = computed(() => this.config().iconColor);
}
